export default "//static.tradera.net/touchweb/static/output/images/category-sports-leisure.ea16daa4.svg";